import {get} from '../shoptools/fetch';

export default function quickSearchInit (form) {
  const input = form.querySelector("input[type='search'], input[type='text']");
  const results = document.querySelector('.eyebrow .search .results');
  let debounceSubmit;
  // submit form
  const submit = () => {
    const url = `${form.getAttribute('data-ajax-action')}`;
    get(url, {'ajax': 1, 'q': input.value}).then((response) => {
      return response.json();
    }).then((data) => {
      results.innerHTML = data.html_snippet;
    });
  };
  // bind keyup listener
  input.addEventListener('keyup', (e) => {
    // prevent to many call
    window.clearTimeout(debounceSubmit);
    debounceSubmit = setTimeout(function () {
      submit();
    }, 300);
  });
}



// WEBPACK FOOTER //
// ./assets/j/src/quick-search.js